import { render, staticRenderFns } from "./share_award_product.vue?vue&type=template&id=ee669f4c"
import script from "./share_award_product.vue?vue&type=script&lang=js"
export * from "./share_award_product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports